import _get from 'lodash/get';

import {
    chatbotCTAClick,
    chatbotImpression,
    electricVehicleChargeTimeCTAClick,
    electricVehicleViewDetailsBatteryDegradationClick,
    myWalletDealBannerImpression,
    myWalletViewDealStatusCTAClick,
    ndsInsuranceSponsorInviewImpression,
    page,
    snapshotPaymentDetailsClick as reaxlSnapshotPaymentDetailsClick,
} from 'reaxl-analytics-handlers';

import queryDuck from '@/ducks/queryDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import { searchLinkClick } from './inventoryDealerEvents';
import { listingPaymentCTAClick } from './inventoryPaymentsEvents';
import { ownerNextCTAClick } from './srp/owner/ownerActionEvents';
import { ownerPhoneNumberImpressions } from './srp/owner/ownerLeadEvents';
import { dhsImpressions } from './vdp/inventoryFilterEvents';
import { inventoryBadgeClick, inventoryDetailAccordionClick, inventoryProtectionReadMoreClick } from './vdp/inventoryProductEvents';
import { backToResultsLinkClick, inventoryVdpPaginationClick, inventoryViewAvailableOffersClick } from './vdp/inventoryVehicleDetailsEvents';
import { dealerSegmentationImpression, viewMoreVehiclesImpression } from './vdp/vdpInventoryDealerEvents';
import { inventoryViewSpecificationsClick } from './vdp/vdpInventoryEvents';
import { pricingOverviewClick } from './vdp/vdpInventoryPaymentsEvents';

export const snapshotPaymentDetailsClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

    return reaxlSnapshotPaymentDetailsClick({
        ...metadata,
        data: {
            ...data,
            inventoryId: data.inventoryId || activeInventory.id,
        },
    }, option);
};

export default {
    page: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        const { id, owner = {} } = activeInventory;
        const pageEvents = [];
        const homeServices = _get(owner, 'homeServices');

        if (homeServices && Object.keys(homeServices).length > 0) {
            // sets event81
            pageEvents.push('dhsVDP');
        }

        return page({
            ...metadata,
            data: {
                ...data,
                pageType: id ? 'vdp' : 'other',
                pageEvents,
                domainKey: 'vdp',
                inventoryId: activeInventory.id,
            },
            queryDuck,
        }, option);
    },
    chatbotCTAClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        return chatbotCTAClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    chatbotImpression: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return chatbotImpression({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    dhsImpressions: (metadata, option) => dhsImpressions({
        ...metadata,
    }, option),
    dealerSegmentationImpression: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return dealerSegmentationImpression({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    electricVehicleChargeTimeCTAClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return electricVehicleChargeTimeCTAClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    electricVehicleViewDetailsBatteryDegradationClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return electricVehicleViewDetailsBatteryDegradationClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    inventoryBadgeClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return inventoryBadgeClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    inventoryDetailAccordionClick: (metaData, option) => {
        const { data, state } = metaData;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        const detailSection = _get(metaData, 'data.key', 'vehicle-detail');

        return inventoryDetailAccordionClick({
            ...metaData,
            data: {
                inventoryId: activeInventory?.id,
                detailSection,
                isPsxVdp: data?.isPsxVdp,
            },
        }, option);
    },
    inventoryProtectionReadMoreClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return inventoryProtectionReadMoreClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    inventoryVdpPaginationClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return inventoryVdpPaginationClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },
    inventoryViewSpecificationsClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return inventoryViewSpecificationsClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    inventoryViewAvailableOffersClick: (metadata, option) => {
        const { state, data } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return inventoryViewAvailableOffersClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    listingPaymentCTAClick: (metadata, option) => listingPaymentCTAClick({
        ...metadata,
    }, option),
    pricingOverviewClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        return pricingOverviewClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory.id,
            },
        }, option);
    },
    searchLinkClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        return searchLinkClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    backToResultsLinkClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        return backToResultsLinkClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    viewMoreVehiclesImpression: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return viewMoreVehiclesImpression({
            ...metadata,
            data: {
                ...data,
                label: 'View More Vehicles Like This',
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
    ownerNextCTAClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return ownerNextCTAClick({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
        }, option);
    },

    ownerPhoneNumberImpressions: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return ownerPhoneNumberImpressions({
            ...metadata,
            data: {
                inventoryId: activeInventory?.id,
                ...data,
            },
            filterDuck: vdpResultsDuck,
        }, option);
    },

    myWalletDealBannerImpression: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return myWalletDealBannerImpression({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },

    myWalletViewDealStatusCTAClick: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return myWalletViewDealStatusCTAClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },

    ndsInsuranceSponsorInviewImpression: (metadata, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return ndsInsuranceSponsorInviewImpression({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory?.id,
            },
        }, option);
    },
};
